import { Injectable } from '@angular/core';
import { AuthenticationService } from "../authentication.service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";


@Injectable()
export class InSalesService {

  constructor(private auth: AuthenticationService, private http: Http) { }
  //--------------Customer-----------------//
  getCustomer(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Customer",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getCustomerById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CustomerById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  saveCustomer(Customer: any) {
    if (Customer.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Customer",
          Customer,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Customer",
          Customer,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  CodeDuplication(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Customer_CodeDuplication",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_CustomerByBranch(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_CustomerByBranch",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Customer-----------------//
  //--------------Backofficesale-----------------//
  GetBackofficeSales(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Backofficesale",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getBackofficesaleById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_backofficeById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getBackofficesaleByDate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BackofficesalesByDate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getBackofficesaleByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_BackofficeByVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveBackofficesale(BackofficeSales_Master: any) {
    if (BackofficeSales_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Backofficesales",
          BackofficeSales_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Backofficesales",
          BackofficeSales_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteBackofficesale(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_Backofficesales", Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getPOSContactSearch(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/POS/Get_POSContactSearch",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getPOSContactByMobile(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/POS/Get_POSContactbyMobileNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSalescontactHistory(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/POS/Get_SalesHistoryByContacts",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getClosingStock_ForSales(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ClosingStock_ForSales",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getDeliveryNoteForBOSale(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryNote_ForBOSale",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SODN_StatusonBOSave(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SO/DN_StatusonBOSave",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Validate_SalesOrderForBO(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Validate_SalesOrderForBO",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_HistoryForBackOfficeSales(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_HistoryForBackOfficeSales",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_BOStatus(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_BOStatus",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Generate_BoInvoiceNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Generate_BoInvoiceNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Get_StockHistoryForBOSales(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_StockHistoryForBOSales",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_SOStatus(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SOStatus",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Backofficesale-----------------//
  //--------------Saleaman-----------------//
  getSalesman(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Salesman",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  getSalesmanById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesmanById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  saveSalesman(salesman: any) {
    if (salesman.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Salesman",
          salesman,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .put(
          this.auth.baseUrl + "/services/api/v1/Update_Salesman",
          salesman,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteSalesman(id: number) {
    return this.http
      .delete(
        this.auth.baseUrl + "/services/api/v1/Delete_Salesman?Id=" + id,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  //--------------Saleaman-----------------//

  //--------------Consumption-----------------//
  GetConsumption(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Consumption",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetConsumptionVoucherNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_ConsumptionVoucherNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getConsumptionById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Consumption_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getConsumptionShowgenerate(Filter: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/GetConsumptionShowgenerate",
        Filter,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });

  }
  saveConsumption(Consumption_Master: any) {
    if (Consumption_Master.Id == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Consumption",
          Consumption_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
    else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Consumption",
          Consumption_Master,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteConsumption(Id: any) {
    if (Id != 0) {
      return this.http
        .get(
          this.auth.baseUrl + "/services/api/v1/Delete_Consumption?Id=" + Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  Autopost_Consumption(consumptionmaster: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Autopost_Consumption",
        consumptionmaster,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //--------------Consumption-----------------//
  // ---------------------Quotation--------------------------------------------
  GetQuotation(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Quotation",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetQuotationNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_QuotationNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getQuotationById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_Quotation_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveQuotation(Model: any) {
    if (Model.QuotationID == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_Quotation",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_Quotation",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteQuotation(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_Quotation", Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  Get_QuotationSearch(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_QuotationSearch", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_Quotation_Status(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_Quotation_Status", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_QuotationByIdForSO(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_QuotationByIdForSO", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // ---------------------Quotation--------------------------------------------
  // ---------------------SalesOrder--------------------------------------------
  GetSalesOrder(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrder",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  GetSalesOrderNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrderNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSalesOrderById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrder_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSalesOrderByIdOnSOLoad(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrder_ById_OnSOLoad",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  saveSalesOrder(Model: any) {
    if (Model.SalesOrderId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_SalesOrder",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_SalesOrder",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteSalesOrder(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_SalesOrder", Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  get_SalesOrderSearch(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrderSearch", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SalesOrder_Status(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SalesOrder_Status", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSOIdforBOSale(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SOIdforBOSale",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // ---------------------SalesOrder--------------------------------------------
  // ---------------------DeliveryNote--------------------------------------------
  get_DeliveryNote(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryNote",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  get_DeliveryNoteNo(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryNoteNo",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  get_DeliveryNote_ById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryNote_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_DeliveryNote(Model: any) {
    if (Model.DeliveryNoteId == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_DeliveryNote",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_DeliveryNote",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  delete_DeliveryNote(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_DeliveryNote", Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  get_DeliveryNoteSearch(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryNoteSearch", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  get_SalesOrderSearch_ForBOSale(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrderSearch_ForBOSale", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_DeliveryNoteStatus(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_DeliveryNoteStatus", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DeliveryNoteBySo(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryNoteBySo", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_SalesOrder_ForBo(filteritems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesOrder_ForBo", filteritems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // ---------------------DeliveryNote--------------------------------------------
  // ---------------------SalesReturn--------------------------------------------
  getSalesReturn(FilterItems: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesReturn",
        FilterItems,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  getSalesReturnById(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesReturn_ById",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  save_SalesReturn(Model: any) {
    if (Model.SalesReturnID == 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Save_SalesReturn",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    } else {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Update_SalesReturn",
          Model,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  deleteSalesReturn(Id: any) {
    if (Id != 0) {
      return this.http
        .post(
          this.auth.baseUrl + "/services/api/v1/Delete_SalesReturn", Id,
          this.auth.getHeader()
        )
        .map(res => {
          return res.json();
        });
    }
  }
  getSalesReturnByVoucherNo(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_SalesReturnByVoucherNo",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Update_SalesReturnStatus(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_SalesReturnStatus",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  // ---------------------SalesReturn--------------------------------------------
  //-----------------------DeliveryMgmt----------------------------------------
  Get_DeliveryInvList(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DeliveryInvList",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }

  Update_DeliveryStatus(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Update_DeliveryStatus",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Get_DriverForDelivery(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Get_DriverForDelivery",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------------DeliveryMgmt----------------------------------------
  //-----------------------Zatca Integration-----------------------------------
  Zatca_InvoiceGenerate(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Zatca_InvoiceGenerate",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  Zatca_GenerateQrCode(Body: any) {
    return this.http
      .post(
        this.auth.baseUrl + "/services/api/v1/Zatca_GenerateQrCode",
        Body,
        this.auth.getHeader()
      )
      .map(res => {
        return res.json();
      });
  }
  //-----------------------Zatca Integration-----------------------------------
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/services/inventory/in-sales.service.ts